<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row mb-3x">
    <label class="col-sm-9"
           for="bisherigeTaetigkeitVorhanden">{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.VORTAETIGKEIT.TITEL' | translate }}</label>
    <div class="col-sm-3">
      <select class="form-control" formControlName="bisherigeTaetigkeitVorhanden" id="bisherigeTaetigkeitVorhanden"
              utilsControlState>
        <option [ngValue]="null"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.VORTAETIGKEIT.VORHANDEN.NULL' | translate }}</option>
        <option [ngValue]="true"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.VORTAETIGKEIT.VORHANDEN.JA' | translate }}</option>
        <option [ngValue]="false"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.VORTAETIGKEIT.VORHANDEN.NEIN' | translate }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="data?.bisherigeTaetigkeitVorhanden">
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="bisherigeTaetigkeit">{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.VORTAETIGKEIT.ART' | translate }}</label>
      <div class="col-sm-8">
        <textarea class="form-control" datevMessagePath="bisherigeTaetigkeit{{objectId}}" formControlName="bisherigeTaetigkeit" id="bisherigeTaetigkeit"
                  rows="3"
                  type="text" utilsCheckValidity
                  utilsControlState utilsValidationMessage></textarea>
      </div>
    </div>

    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="ort">{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.VORTAETIGKEIT.ORT' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="ort{{objectId}}" formControlName="ort" id="ort"
               type="text" utilsCheckValidity
               utilsControlState utilsValidationMessage/>
      </div>
    </div>

    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="dauerVon">{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.VORTAETIGKEIT.DAUER_VON' | translate }}</label>
      <div class="col-sm-8">
        <date-picker
                id="dauerVon"
                messagePath="dauerVon"
                formControlName="dauerVon"
                [isRequired]=false>
        </date-picker>
      </div>
    </div>

    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="dauerBis">{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.VORTAETIGKEIT.DAUER_BIS' | translate }}</label>
      <div class="col-sm-8">
        <date-picker
                id="dauerBis"
                messagePath="dauerBis"
                formControlName="dauerBis"
                [isRequired]=false>
        </date-picker>
      </div>
    </div>

    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="ustIdentifikationsnummer">{{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEBETRIEBLICHEVERHAELTNISSE.VORTAETIGKEIT.USTID' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="ustIdentifikationsnummer{{objectId}}" formControlName="ustIdentifikationsnummer" id="ustIdentifikationsnummer"
               type="text" utilsCheckValidity
               utilsControlState utilsValidationMessage/>
      </div>
    </div>

    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="wirtschaftsIdNummer">{{ 'COMMON_UI.STEUERIDENTIFIKATION.WIRTSCHAFTS_ID_NUMMER' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="wirtschaftsIdNummer{{objectId}}" formControlName="wirtschaftsIdNummer" id="wirtschaftsIdNummer"
               type="text" utilsCheckValidity
               utilsControlState utilsValidationMessage/>
      </div>
    </div>
  </div>
</form>
